export const Footer = () => {
  const year = new Date().getFullYear();

  return <footer>{`Copyright © R. A. Woodworth ${year}`}</footer>;
};
